const hexToRgb = (hex: string) => {
  if (!hex) return [0, 0, 0];
  hex = hex.replace(/^#/, '');

  if (hex.length === 3) {
    hex = hex
      .split('')
      .map((char) => char + char)
      .join('');
  }

  const bigint = parseInt(hex, 16);
  const r = (bigint >> 16) & 255;
  const g = (bigint >> 8) & 255;
  const b = bigint & 255;

  return [r, g, b];
};

export const getContrastingTextColor = (hexColor?: string): string => {
  if (!hexColor) return 'black';
  const [r, g, b] = hexToRgb(hexColor);
  const brightness = 0.299 * r + 0.587 * g + 0.114 * b;

  return brightness > 186 ? 'black' : 'white';
};
